// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_6AQ","cls2":"ImpactStatTile-cls2_Q6z ImpactStatTile-cls1_6AQ"};